<mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
<div [ngClass]="{ zonaoculta: loading === true }">
  <app-buttons
    (save)="submit()"
    (close)="destroy()"
    (discard)="discard()"
    [buttonsWrap]="'panel'"
    [modificar]="modificar"
  ></app-buttons>

  <div class="divForm" id="arriba">
    <form [formGroup]="editInternetGroupForm" (onSubmit)="submit()">
      <div class="form-group">
        <div class="col-sm-12 col-md-6">
          <mat-form-field appearance="outline">
            <mat-label>{{ translation.Nombre }}</mat-label>
            <input matInput formControlName="Nombre" />
          </mat-form-field>
        </div>
        <div class="col-sm-12 col-md-6">
          <mat-form-field appearance="outline">
            <mat-select
              placeholder="{{ translation.Idioma }}"
              formControlName="Idioma"
            >
              <mat-option
                *ngFor="let idioma of idiomasApp"
                [value]="idioma.CodIdioma"
              >
                {{ idioma.Nombre }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="form-group">
        <div class="col-sm-12 col-md-6">
          <mat-form-field appearance="outline">
            <mat-label>{{ translation.Descripcion }}</mat-label>
            <input matInput formControlName="Descripcion" />
          </mat-form-field>
        </div>
        <div class="col-sm-12 col-md-6">
          <mat-form-field appearance="outline">
            <mat-label>{{ translation.Orden }}</mat-label>
            <input matInput formControlName="Orden" />
          </mat-form-field>
        </div>
      </div>
      <div class="form-group">
        <div class="col-sm-12 col-md-6">
          <mat-form-field appearance="outline">
            <mat-label>{{ translation.Maximo }}</mat-label>
            <input type="number" matInput formControlName="Maximo" />
          </mat-form-field>
        </div>
        <div class="col-sm-12 col-md-6">
          <mat-form-field appearance="outline">
            <mat-label>{{ translation.Minimo }}</mat-label>
            <input type="number" matInput formControlName="Minimo" />
          </mat-form-field>
        </div>
      </div>
      <div class="form-group">
        <div class="col-sm-12 col-md-6">
          <app-input-filter
            *ngIf="internetgroup && TiposReservas && TiposReservas.length > 0"
            formControlText="TipoReservaId"
            [label]="translation.TipoReserva"
            [placeHolderTranslation]="translation.TipoReserva"
            [list]="TiposReservas"
            [disabled]="TiposReservas.length < 1"
            textShow="Nombre"
            dataInput="pkId"
            required="true"
            [data]="internetgroup.TipoReservaId"
            (close)="closeInputFilter($event)"
          ></app-input-filter>
          <!-- <mat-form-field appearance="outline">
        <mat-label>{{translation.TipoReserva}}</mat-label>
        <mat-select formControlName="TipoReservaId">
          <mat-option *ngFor="let reservaTipo of TiposReservas" [value]="reservaTipo.pkId">
            {{reservaTipo.Nombre}}
          </mat-option>
        </mat-select>
    </mat-form-field> -->
        </div>
        <div class="col-sm-12 col-md-6">
          <mat-form-field appearance="outline">
            <mat-label>{{ translation.ValidarGratuitas }}</mat-label>
            <mat-select formControlName="ValidarGratuitas">
              <mat-option value="0">{{ translation.No }}</mat-option>
              <mat-option value="1">{{ translation.Si }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="form-group">
        <div class="col-sm-12 col-md-6">
          <mat-form-field appearance="outline">
            <mat-label>{{ translation.TipoOperacion }}</mat-label>
            <mat-select formControlName="idTipoOperacion">
              <mat-option value="0">{{
                translation.TipoOperacionNoAplica
              }}</mat-option>
              <mat-option value="1">{{
                translation.TipoOperacionAlta
              }}</mat-option>
              <mat-option value="2">{{
                translation.TipoOperacionRenovacion
              }}</mat-option>
              <mat-option value="3">{{
                translation.TipoOperacionAmpliacion
              }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-sm-12 col-md-6"></div>
      </div>

      <div class="form-group" class="col-sm-12 mb-5 text-center mb-5">
        <!-- <div style="margin: 20px 5px 0 5px; text-align: center"> -->
          <mat-label><strong>{{ translation.EnlaceMenu }}</strong></mat-label>
          <customan-dual-list
            [source]="source"
            [destination]="confirmados"
            [copyList]="cplist"
            key="pkId"
            display="Nombre"
            [filter]="filter"
            [format]="format"
          ></customan-dual-list>
      </div>

      <div class="form-group" class="col-sm-12 mb-5 text-center mb-5">
          <mat-label><strong>{{ translation.Centros }}</strong></mat-label>
          <customan-dual-list
            [source]="centrosSinAsignar"
            [(destination)]="centrosAsignados"
            key="pkId"
            display="Nombre"
            [format]="format"
            [filter]="filter"
          >
          </customan-dual-list>
      </div>

      <div *ngFor="let idioma of editorListaIdiomas" class="form-group mb-5">
           <div class="col-sm-12">
            <div class="row no-gutters">
              <div class="col-sm-6">
                <mat-form-field appearance="outline">
                  <mat-label
                    >{{ translation.NombreInternet }} ({{
                      idioma.CodIdioma
                    }})</mat-label
                  >
                  <input
                    matInput
                    type="text"
                    placeholder="{{ translation.Nombre }} en {{ idioma.Nombre }}"
                    [value]="idioma.Nombre"
                    (change)="
                      cambiaNombre($any($event.target).value, idioma.CodIdioma)
                    "
                    formControlName="{{ 'nombre' + idioma.CodIdioma }}"
                  />
                </mat-form-field>
              </div>

              <div class="col-sm-6">
                <mat-form-field appearance="outline">
                  <mat-label
                    >{{ translation.Descripcion }} ({{ idioma.CodIdioma }})</mat-label
                  >
                  <textarea
                    matInput
                    type="text"
                    placeholder="{{ translation.Descripcion }} {{ idioma.Nombre }}"
                    [value]="idioma.Descripcion"
                    formControlName="{{ 'descripcion' + idioma.CodIdioma }}"
                  ></textarea>
                </mat-form-field>
              </div>

              <div class="col-sm-6">
                <mat-form-field appearance="outline">
                  <mat-label
                    >{{ translation.Descripcion }} 1 ({{
                      idioma.CodIdioma
                    }})</mat-label
                  >
                  <textarea
                    matInput
                    type="text"
                    placeholder="{{ translation.Descripcion }} {{ idioma.Nombre }}"
                    [value]="idioma.Descripcion1"
                    formControlName="{{ 'descripcion1' + idioma.CodIdioma }}"
                  ></textarea>
                </mat-form-field>
              </div>

              <div class="col-sm-6">
                <mat-form-field appearance="outline">
                  <mat-label
                    >{{ translation.Descripcion }} 2 ({{
                      idioma.CodIdioma
                    }})</mat-label
                  >
                  <textarea
                    matInput
                    type="text"
                    placeholder="{{ translation.Descripcion }} {{ idioma.Nombre }}"
                    [value]="idioma.Descripcion2"
                    formControlName="{{ 'descripcion2' + idioma.CodIdioma }}"
                  ></textarea>
                </mat-form-field>
              </div>
            </div>
        </div>
      </div>

      <!-- Nuevos campos agregados -->
      <div class="form-group">
        <div class="col-sm-12 col-md-6 mt-3">
          <mat-label
              >{{ translation.Relevante }}
              <mat-slide-toggle
                name="Relevante"
                formControlName="Relevante"
              ></mat-slide-toggle>
            </mat-label>
        </div>
      </div>

      <div class="form-group" class="col-sm-12 mb-5 text-center">
          <mat-label><strong>{{ translation.SEO }}</strong></mat-label>
          <customan-dual-list
            [source]="seosSinAsignar"
            [destination]="seosAsignados"
            [copyList]="cplist"
            key="pkId"
            display="Nombre"
            [filter]="filter"
            [format]="format"
          ></customan-dual-list>
      </div>
			
      <div class="col-sm-12 mb-5 text-center mt-3">
        <h3><strong>{{ translation.InformacionMeraki || 'Información Meraki' }}</strong></h3>
        <mat-accordion *ngFor="let idioma of editorListaInfo; let i = index"  >
          <mat-expansion-panel [expanded]="i == 0">
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{ idioma.Nombre | translateV2 : "CAPITALIZE" }}
              </mat-panel-title>
              <mat-panel-description> </mat-panel-description>
            </mat-expansion-panel-header>

            <mat-form-field appearance="outline">
              <mat-label>{{ translation.Titulo }} ({{ idioma.CodIdioma }})</mat-label>
              <input
                matInput
                type="text"
                placeholder="{{ translation.Titulo }} en {{ idioma.Nombre }}"
                [value]="idioma.Titulo"
                formControlName="{{ 'titulo' + idioma.CodIdioma }}"
              />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label
                >{{ translation.Parrafo1 }} ({{ idioma.CodIdioma }})</mat-label
              >
              <textarea
                matInput
                type="text"
                placeholder="{{ translation.Parrafo1 }} {{ idioma.Nombre }}"
                [value]="idioma.Parrafo1"
                formControlName="{{ 'parrafo1' + idioma.CodIdioma }}"
              ></textarea>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>{{ translation.Parrafo2 }} ({{ idioma.CodIdioma }})</mat-label>
              <textarea
                matInput
                type="text"
                placeholder="{{ translation.Parrafo2 }} {{ idioma.Nombre }}"
                [value]="idioma.Parrafo2"
                formControlName="{{ 'parrafo2' + idioma.CodIdioma }}"></textarea>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>{{ translation.Horario1 }} ({{ idioma.CodIdioma }})</mat-label>
              <textarea
                matInput
                type="text"
                placeholder="{{ translation.Horario1 }} {{ idioma.Nombre }}"
                [value]="idioma.Horario1"
                formControlName="{{ 'horario1' + idioma.CodIdioma }}"></textarea>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>{{ translation.Horario2 }} ({{ idioma.CodIdioma }})</mat-label>
              <textarea
                matInput
                type="text"
                placeholder="{{ translation.Horario2 }} {{ idioma.Nombre }}"
                [value]="idioma.Horario2"
                formControlName="{{ 'horario2' + idioma.CodIdioma }}"></textarea>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>{{ translation.Horario3 }} ({{ idioma.CodIdioma }})</mat-label>
              <textarea
                matInput
                type="text"
                placeholder="{{ translation.Horario3 }} {{ idioma.Nombre }}"
                [value]="idioma.Horario3"
                formControlName="{{ 'horario3' + idioma.CodIdioma }}"></textarea>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>{{ translation.Horario4 }} ({{ idioma.CodIdioma }})</mat-label>
              <textarea
                matInput
                type="text"
                placeholder="{{ translation.Horario4 }} {{ idioma.Nombre }}"
                [value]="idioma.Horario4"
                formControlName="{{ 'horario4' + idioma.CodIdioma }}"></textarea>
            </mat-form-field>

            <!-- TextoAmigable - Ordem da API: após Horario4 -->
            <mat-form-field appearance="outline">
              <mat-label
                >{{ translation.TextoAmigable }} ({{ idioma.CodIdioma }})</mat-label
              >
              <textarea
                matInput
                type="text"
                placeholder="{{ translation.TextoAmigable }} {{ idioma.Nombre }}"
                [value]="idioma.TextoAmigable"
                formControlName="{{ 'textoAmigable' + idioma.CodIdioma }}"
              ></textarea>
            </mat-form-field>

            <!-- Tipo (TipoVisita) - Ordem da API: após TextoAmigable -->
            <mat-form-field appearance="outline">
              <mat-label>{{ translation?.TipoVisita || 'Tipo Visita' }} ({{ idioma.CodIdioma }})</mat-label>
              <textarea
                matInput
                type="text"
                placeholder="{{ translation?.TipoVisita || 'Tipo Visita' }} {{ idioma.Nombre }}"
                [value]="idioma.Tipo"
                formControlName="{{ 'tipoVisita' + idioma.CodIdioma }}"></textarea>
            </mat-form-field>

            <!-- TipoPublico - Ordem da API: após Tipo -->
            <mat-form-field appearance="outline">
              <mat-label>{{ translation?.TipoPublico || 'Tipo Público' }} ({{ idioma.CodIdioma }})</mat-label>
              <textarea
                matInput
                type="text"
                placeholder="{{ translation?.TipoPublico || 'Tipo Público' }} {{ idioma.Nombre }}"
                [value]="idioma.TipoPublico"
                formControlName="{{ 'tipoPublico' + idioma.CodIdioma }}"></textarea>
            </mat-form-field>

            <!-- Copyright - Ordem da API: após TipoPublico -->
            <mat-form-field appearance="outline">
              <mat-label>{{ translation.Copyright }} ({{ idioma.CodIdioma }})</mat-label>
              <input
                matInput
                type="text"
                placeholder="{{ translation.Copyright }} {{ idioma.Nombre }}"
                [value]="idioma.Copyright"
                formControlName="{{ 'copyright' + idioma.CodIdioma }}" />
            </mat-form-field>

            <!-- MetaDescription - Ordem da API: após Copyright -->
            <mat-form-field appearance="outline">
              <mat-label>{{ translation.MetaDescription }} ({{ idioma.CodIdioma }})</mat-label>
              <textarea
                matInput
                type="text"
                placeholder="{{ translation.MetaDescription }} {{ idioma.Nombre }}"
                [value]="idioma.MetaDescription"
                formControlName="{{ 'metaDescription' + idioma.CodIdioma }}"></textarea>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>{{ translation.Ubicacion }} ({{ idioma.CodIdioma }})</mat-label>
              <textarea
                matInput
                type="text"
                placeholder="{{ translation.Ubicacion }} {{ idioma.Nombre }}"
                [value]="idioma.Ubicacion"
                formControlName="{{ 'ubicacion' + idioma.CodIdioma }}"
              ></textarea>
            </mat-form-field>

            <!-- URLExterna - Ordem da API: último campo -->
            <mat-form-field appearance="outline">
              <mat-label>{{ translation.URLExterna }} ({{ idioma.CodIdioma }})</mat-label>
              <textarea
                matInput
                type="text"
                placeholder="{{ translation.URLExterna }} {{ idioma.Nombre }}"
                [value]="idioma.URLExterna"
                formControlName="{{ 'urlexterna' + idioma.CodIdioma }}"
              ></textarea>
            </mat-form-field>

          </mat-expansion-panel>
        </mat-accordion>
      </div>

      <!-- imagenes -->

      <div class="col-sm-12 col-md-12 mt-5 text-center">
        <h3><strong>{{ translation.Imagenes }}</strong></h3>

        <mat-expansion-panel [expanded]="true" collapsable="false" [ngClass]="{ 'image-error-highlight': portadaError }">
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ translation.ImagenPortada }}
            </mat-panel-title>
            <mat-panel-description> </mat-panel-description>
          </mat-expansion-panel-header>

          <div class="row mt-3">
            <!-- <div class="col-sm-1">Portada</div> -->
            <div class="col-sm-4">
              <p class="mb-0">
                {{ translation.ImagenTamano }} 200x400 pixeles
              </p>
              <p class="mb-0">
                {{ translation.ImagenPesoRecomendado }}
              </p>
              <p class="mb-0">
                {{ translation.ImagenFormatoRequerido }}
              </p>
            </div>
            <div class="col-sm-5">
              <img
                  *ngIf="imagenPortada"
                  [src]="imagenPortada"
                  class="img-fluid img-thumbnail image-clickable"
                  alt="Portada"
                  (click)="openImageModal(imagenPortada, sizePortada, translation.ImagenPortada, sizePortadaKB)"
                  style="cursor: pointer;"
                />
            </div>
            <div class="col-sm-3">
              <button
                *ngIf="!imagenPortada"
                class="form-control mb-2 h-25"
                [ngClass]="{ 'image-error-highlight': portadaError }"  
                (click)="fileInputPortada.click()" 
                class="mat-focus-indicator mat-raised-button mat-button-base mat-primary btn-block point-right"> 
                {{ translation.Upload }}
              </button>
              <button
                *ngIf="imagenPortada"
                class="form-control mb-2 h-25"
                [ngClass]="{ 'image-error-highlight': portadaError }"  
                (click)="removeImage(EIMAGES.PORTADA)" 
                class="mat-focus-indicator mat-raised-button mat-button-base mat-secondary btn-block point-right"> 
                {{ translation.UploadRemove }} 
              </button>
              <div *ngIf="imagenPortada" class="mt-4 text-center">
                {{ translation.ImagenSize }}{{ sizePortada }} pixels
                <br *ngIf="sizePortadaKB" />
                <span *ngIf="sizePortadaKB">
                  {{ translation.ImagenPesoActual }} {{ sizePortadaKB }}KB
                </span>
              </div>
            </div>
            <input class="form-control mb-2 h-25 d-none" type="file" #fileInputPortada style="visibility: hidden;" (change)="onFileSelected($event, 'portada')" multiple accept=".jpg,.jpeg" />
          </div>

        </mat-expansion-panel>

        <mat-expansion-panel [expanded]="true" [ngClass]="{ 'image-error-highlight': fichaError }">
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ translation.ImagenFicha }}
            </mat-panel-title>
            <mat-panel-description> </mat-panel-description>
          </mat-expansion-panel-header>

          <div class="row mt-3">
            <div class="col-sm-4">
              <p class="mb-0">
                {{ translation.ImagenTamano }} 500x500 pixeles
              </p>
              <p class="mb-0">
                {{ translation.ImagenPesoRecomendado }}
              </p>
              <p class="mb-0">
                {{ translation.ImagenFormatoRequerido }}
              </p>
            </div>
            <div class="col-sm-5">
              <img
                  *ngIf="imagenFicha"
                  [src]="imagenFicha"
                  class="img-fluid img-thumbnail image-clickable"
                  alt="Ficha"
                  (click)="openImageModal(imagenFicha, sizeFicha, translation.ImagenFicha, sizeFichaKB)"
                  style="cursor: pointer;"
                />
            </div>
            <div class="col-sm-3">
              <button
                *ngIf="!imagenFicha"
                class="form-control mb-2 h-25"
                [ngClass]="{ 'image-error-highlight': fichaError }"  
                (click)="fileInputFicha.click()" 
                class="mat-focus-indicator mat-raised-button mat-button-base mat-primary btn-block point-right"> 
                {{ translation.Upload }}
              </button>
              <button
                *ngIf="imagenFicha"
                class="form-control mb-2 h-25"
                [ngClass]="{ 'image-error-highlight': fichaError }"  
                (click)="removeImage(EIMAGES.FICHA)" 
                class="mat-focus-indicator mat-raised-button mat-button-base mat-secondary btn-block point-right"> 
                {{ translation.UploadRemove }}
              </button>
              <div *ngIf="imagenFicha" class="mt-4 text-center">
                {{ translation.ImagenSize }}{{ sizeFicha }} pixels
                <br *ngIf="sizeFichaKB" />
                <span *ngIf="sizeFichaKB">
                  {{ translation.ImagenPesoActual }} {{ sizeFichaKB }}KB
                </span>
              </div>
            </div>
            <input class="form-control mb-2 h-25 d-none" type="file" #fileInputFicha style="visibility: hidden;" (change)="onFileSelected($event, 'ficha')" multiple accept=".jpg,.jpeg" />
          </div>

        </mat-expansion-panel>

        <mat-expansion-panel [expanded]="true" [ngClass]="{ 'image-error-highlight': pdfError }">
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ translation.ImagenPDF }}
            </mat-panel-title>
            <mat-panel-description> </mat-panel-description>
          </mat-expansion-panel-header>

          <div class="row mt-3">
            <div class="col-sm-4">
              <p class="mb-0">
                {{ translation.ImagenTamano }} 500x500 o 500x590 pixeles
              </p>
              <p class="mb-0">
                {{ translation.ImagenPesoRecomendado }}
              </p>
              <p class="mb-0">
                {{ translation.ImagenFormatoRequerido }}
              </p>
            </div>
            <div class="col-sm-5">
              <img
                  *ngIf="imagenPdf"
                  [src]="imagenPdf"
                  class="img-fluid img-thumbnail image-clickable"
                  alt="Pdf"
                  (click)="openImageModal(imagenPdf, sizePdf, translation.ImagenPDF, sizePdfKB)"
                  style="cursor: pointer;"
                />
            </div>
            <div class="col-sm-3">
              <button
                *ngIf="!imagenPdf"
                class="form-control mb-2 h-25"
                [ngClass]="{ 'image-error-highlight': pdfError }"  
                (click)="fileInputPdf.click()" 
                class="mat-focus-indicator mat-raised-button mat-button-base mat-primary btn-block point-right"> 
                {{ translation.Upload }}
              </button>
              <button
                *ngIf="imagenPdf"
                class="form-control mb-2 h-25"
                [ngClass]="{ 'image-error-highlight': pdfError }"  
                (click)="removeImage(EIMAGES.PDF)" 
                class="mat-focus-indicator mat-raised-button mat-button-base mat-secondary btn-block point-right"> 
                {{ translation.UploadRemove }}
              </button>
              <div *ngIf="imagenPdf" class="mt-4 text-center">
                {{ translation.ImagenSize }}{{ sizePdf }} pixels
                <br *ngIf="sizePdfKB" />
                <span *ngIf="sizePdfKB">
                  {{ translation.ImagenPesoActual }} {{ sizePdfKB }}KB
                </span>
              </div>
            </div>
            <input class="form-control mb-2 h-25 d-none" type="file" #fileInputPdf style="visibility: hidden;" (change)="onFileSelected($event, 'pdf')" multiple accept=".jpg,.jpeg" />
          </div>

        </mat-expansion-panel>

      </div>

    </form>
  </div>
</div>
